
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class DomainRenewalInfoModel extends Model<DomainRenewalInfoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'awaitingProvider', type: 'boolean' },
		{ name: 'expireDate', type: 'Date' },
		{ name: 'renewalPeriodMonths', type: 'number' },
		{ name: 'registrantValidated', type: 'boolean' },
		{ name: 'registrarManaged', type: 'boolean' },
		{ name: 'registrarAction', type: 'string' },
		{ name: 'registrarActionCompleted', type: 'boolean' }
	];
	[key: string]: any;
	
	public awaitingProvider: boolean;
	public expireDate?: Date;
	public renewalPeriodMonths?: number;
	public registrantValidated?: boolean;
	public registrarManaged: boolean;
	public registrarAction: string;
	public registrarActionCompleted: boolean;
    
	constructor(){
		super();
		this.awaitingProvider = false;
		this.expireDate = undefined;
		this.renewalPeriodMonths = undefined;
		this.registrantValidated = undefined;
		this.registrarManaged = false;
		this.registrarAction = '';
		this.registrarActionCompleted = false;
		
	}
	getProperties(){
		return DomainRenewalInfoModel.classProperties;
	}
}

